import React from 'react';
import { CameraIcon } from './PickScanBar';
import './PackingPhotoSheet.css';

export const SELECT_BOX_PROMPT = 'Select a box for the order and scan when ready';

interface SelectBoxPromptProps {
  readonly onScan: () => void;
  readonly onSkip: () => void;
}

export default function SelectBoxPrompt({ onScan, onSkip }: SelectBoxPromptProps): React.ReactElement {
  return (
    <div className="packing-photo-sheet select-box-prompt" role="dialog" aria-modal="true" aria-label={SELECT_BOX_PROMPT}>
      <div className="packing-photo-stage select-box-prompt-stage">
        <p className="suggested-box-copy">{SELECT_BOX_PROMPT}</p>
        <button
          type="button"
          className="select-box-camera"
          onClick={onScan}
          aria-label="Scan box size"
        >
          <CameraIcon size={56} />
        </button>
        <button
          type="button"
          className="select-box-skip"
          onClick={onSkip}
        >
          Skip
        </button>
      </div>
    </div>
  );
}
